


export class BtnTypesHelper {

    static TYPES = [
        {
            id: 'product',
            text: 'Товар'
        },
        {
            id: 'category',
            text: 'Категория'
        },
        {
            id: 'profile-info',
            text: 'Профиль информация'
        },
        {
            id: 'profile-orders',
            text: 'Профиль заказы'
        },
        {
            id: 'profile-promocodes',
            text: 'Профиль промокоды'
        },
        {
            id: 'profile-addresses',
            text: 'Профиль адреса'
        },
        {
            id: 'profile-bonuses',
            text: 'Профиль бонусы'
        },
        {
            id: 'profile-reviews',
            text: 'Профиль отзывы'
        },
        {
            id: 'home',
            text: 'Главная'
        },
        {
            id: 'link',
            text: 'Ссылка'
        },
    ];



}